import React, { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { Spinner } from "reactstrap";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { loadReducersForRoute } from "../store/lazyReducerLoader";

// Loading fallback component
const LoadingFallback = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="text-center">
                <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                <p className="mt-2">Loading...</p>
            </div>
        </div>
    );
};

// Component to handle reducer loading on route change
const RouteReducerLoader = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        // Load reducers for the current route
        loadReducersForRoute(location.pathname).catch(error => {
            console.error("Error loading reducers for route:", error);
        });
    }, [location.pathname]);

    return <>{children}</>;
};

const Index = () => {
    return (
        <React.Fragment>
            <Suspense fallback={<LoadingFallback />}>
                <RouteReducerLoader>
                    <Routes>
                        <Route>
                            {publicRoutes.map((route, idx) => (
                                <Route
                                    path={route.path}
                                    element={
                                        <NonAuthLayout>
                                            {route.component}
                                        </NonAuthLayout>
                                    }
                                    key={idx}
                                    exact={true}
                                />
                            ))}
                        </Route>

                        <Route>
                            {authProtectedRoutes.map((route, idx) => (
                                <Route
                                    path={route.path}
                                    element={
                                        <AuthProtected>
                                            <VerticalLayout>{route.component}</VerticalLayout>
                                        </AuthProtected>}
                                    key={idx}
                                    exact={true}
                                />
                            ))}
                        </Route>
                    </Routes>
                </RouteReducerLoader>
            </Suspense>
        </React.Fragment>
    );
};

export default Index;